/**
 * 
 */
export default class RestApi {
  test = {
    test: () => $app.api.get([ 'test', ]),
  }

  auth = {
    login: (data) => $app.api.post([ 'auth/login', ]).data(data),
    // loginBy: (data) => $app.api.post([ 'auth/login-by-token', ]).data(data),
    // info: () => $app.api.get([ 'auth/info', ]),
  }

  user = {
    info: (iin) => $app.api.get([ 'fingerprinting/find-user*', iin ]),
    getStatus: (id) => $app.api.get([ 'fingerprinting/scan/status', id ]),
    createVisit: (data) => $app.api.post([ 'fingerprinting/make-visit', ]).data(data),
    createBreak: (data) => $app.api.post([ 'sheet-breaks', ]).data(data),
  }
}
